import React, { FC } from "react";
import { TextAreaStyled } from "./elements";

type Props = {
  placeholder?: string;
  value?: string;
  onChange?: (e: any) => void;
  disabled?: boolean;
  defaultValue?: string;
};

const TextArea: FC<Props> = (props) => {
  const { placeholder, value, onChange, disabled, defaultValue } = props;

  return (
    <TextAreaStyled
      placeholder={placeholder || ""}
      autoSize={{ minRows: 2 }}
      value={value}
      onChange={onChange}
      disabled={disabled || false}
      defaultValue={defaultValue || ""}
    />
  );
};

export default TextArea;
